import { Component, OnInit } from '@angular/core';
import { BasePage } from '../../../base-page/base-page';
import { piArrowRight, PwcIconsLibrary } from '@pwc-bei/icons';
import { SocietiesService, Society, User, UserService } from '@pwc-bei/common';
import { AuthenticationService, AuthorizationService } from '@pwc-bei/security';
import { Router } from '@angular/router';
import { environment } from '../../../../../environments/environment';
import { RoutePath } from '../../../../enums/route-path.enum';
import { SocietySelectionUtils } from '../../../../utils/society-selection-utils';
import { AuthorityCodeEnum } from '../../../../enums/security/authority-code.enum';

@Component({
    selector: 'app-redirect-to-b2b',
    templateUrl: './redirect-to-b2b.component.html',
    styleUrls: ['./redirect-to-b2b.component.scss'],
    standalone: false
})
export class RedirectToB2bComponent implements OnInit {
  constructor() {}

  ngOnInit(): void {
    window.location.href = `${window.location.origin}/${RoutePath.B2B}`;
  }
}
